
export class Text{
    lang : string
    type : number
    order : number
    text : string

    constructor(values: Object = {}) {
        (<any>Object).assign(this, values);
    }

}

export class CategoriesTree {
    url_base_img : string
    category : Category
    auth : boolean
       
    constructor(values: Object = {}) {
        (<any>Object).assign(this, values);
        this.category = new Category(this.category, null);
    }

    public getLevel(row : number, level : number ) : Category[]{
        if (this.category.childs){
            return this.category.childs.filter( category => { 
                //return category.level == level && category.row == row && category.visible == true && category.childs.length > 0 && category.leaf_count > 0;
                return category.level == level && category.row == row && category.visible == true ; //  && category.childs.length > 0;
            });
        } 
        return [];
    }

    public getCategory (query : string) : Category {
        return this.category.findByLinkId(query);
    }

    
}

export class Category {
    level : number
    row : number
    visible: boolean
    parent : Category
    childs : Category[]
    texts : Text[]
    id : string
    icon : string
    leaf_count : number
    order : number
    banner_id : number

    promo_type : number
    promo_subtype : number

    batch_cents : number

    constructor(values: Object = {}, parent : Category) {
        (<any>Object).assign(this, values);
        this.parent = parent;
        
        if (this.childs) {
            this.childs = this.childs.map(item => new Category(item, this))
                .sort( (a : Category, b: Category) => { 
                    return a.order - b.order;
                });
        }
        if (this.texts) {
            this.texts = this.texts.map(item => new Text(item));
        }
        
    }

    public get batch_price (){
        return this.batch_cents / 100;
    }

    getText(lang: string) : string {
        let text : Text;

        if (this.promo_type == null)
            text = this.texts.find ( text => text.type == 1 && text.lang == lang )
        else
            text = this.texts.find ( text => text.type == 9 && text.lang == lang && text.order == 1)
        if (text){
            return text.text;
        }
        return '';
    }

    getPromoTexts(lang: string) : Text[] {
        return this.texts.filter ( text => text.type == 9 && text.lang == lang );
    }

    getPromoImage(lang: string) : string {
        const imgSrc : Text = this.texts.find ( text => text.type == 10 && text.lang == lang );
        if (imgSrc && imgSrc.text) {
            return imgSrc.text
        }
        return '';
    }

    getLinkId(lang: string) : string {
        const linkText : Text = this.texts.find ( text => text.type == 7 && text.lang == lang );
        if (linkText && linkText.text) {
            return linkText.text
        }
        return this.id;
    }

    getIcon(lang: string) : string {
        let text : Text;
        text = this.texts.find ( text => text.type == 8 && text.lang == lang );
        if (text){
            return text.text;
        }
        return '';
    }

    hasChilds() : boolean {
        return this.childs.length > 0;
    }
    
    getChilds() : Category[]{
        return this.childs.filter( category => {
            //   return category.visible == true && category.leaf_count > 0 ;
            return category.visible == true;
        })
        .sort( (a : Category, b: Category) => { 
            return a.order - b.order;
        });
    }

    findByLinkId (categoryQuery : string ) : Category {
        let ret : Category = null;

        if ( this.id == categoryQuery || this.texts.some( text => { return text.type == 7 &&  text.text.toLowerCase() == categoryQuery.toLocaleLowerCase() })) { 
            return this;            
        }

        let i = 0;

        while (!ret  && i < this.childs.length ){
            ret = this.childs[i].findByLinkId(categoryQuery);
            i++;
        }
        
        return ret;
    }

    getBreadCrumbs () : Category[] {
        let current : Category = this;
        let ret : Category[] = [];

        while (current.parent){
            ret.push(current) ;
            current = current.parent;
        }

        return ret.reverse();

    }



}


export class Filter {
    public name : string
    public count : number

    constructor(name : string){
        this.name = name;
        this.count = 1;
    }
}

export class InfoLog{
    back_color : string
    icon : string
    qty_milis : number
    texts : Text[]

    constructor(values: Object = {}) {
        (<any>Object).assign(this, values);
    }

    getQuantity() : number {
        return this.qty_milis / 1000;
    }

    getTitle(lang: string) : string {
        const text : Text = this.texts.find ( text => text.type == 6 && text.lang == lang );
        if (text && text.text) {
            return text.text
        }
        return '';
    }
    
    getDescription(lang: string) : string {
        const text : Text = this.texts.find ( text => text.type == 4 && text.lang == lang );
        if (text && text.text) {
            return text.text
        }
        return '';
    }

}
